import { createSelector } from '@ngrx/store';
import { selectAllDepartments } from './entity-store-selectors';

export function selectDepartmentById(departmentId: string) {
  return createSelector(selectAllDepartments, (departments) => departments.get(departmentId));
}

export function selectDepartmentByCode(departmentCode: string) {
  return createSelector(selectAllDepartments, (departments) => {
    return departments.valueSeq().find((d) => d.code === departmentCode);
  });
}
